class PromoBarMetaobject extends HTMLElement {
  constructor() {
    super();
    this.activeTimer = this.dataset.activeTimer;
    this.timerDateToExpire = this.dataset.timerDateToExpire;
  }

  connectedCallback() {
    this.closePromoBarBtn = this.querySelector("#close-promo-bar-metaobject");

    this.closePromoBarBtn?.addEventListener("click", () => {
      this.style.display = "none";
    });

    if (this.activeTimer === "true") {
      this.timerContainer = this.querySelector("#promo-bar-metaobject--timer");
      this.timerCounter = this.querySelector(
        "#promo-bar-metaobject--timer-counter"
      );
      this.timer();
    }

    // Retrieve Klaviyo popup settings
    this.openKlaviyoPopupOnClick =
      this.dataset.openKlaviyoPopupOnClick === "true";
    this.klaviyoPopupIdDesktop = this.dataset.klaviyoPopupIdDesktop;
    this.klaviyoPopupIdMobile = this.dataset.klaviyoPopupIdMobile;

    // Find the promo bar link
    this.promoBarLink = this.querySelector("a");

    // Bind the click handler
    this.handlePromoBarClick = this.handlePromoBarClick.bind(this);

    // Add the click event listener
    this.promoBarLink?.addEventListener("click", this.handlePromoBarClick);
  }

  disconnectedCallback() {
    this.closePromoBarBtn?.removeEventListener();
  }

  timer() {
    const eventTime = moment.tz(this.timerDateToExpire, "US/Pacific");
    const currentTime = moment.tz();
    let duration = moment.duration(eventTime.diff(currentTime));

    let intervalId = setInterval(() => {
      duration = moment.duration(duration - 1000, "milliseconds");
      if (duration.asSeconds() <= 0) {
        this.timerCounter.innerHTML = "00:00:00:00";
        this.timerContainer.display = "none";
        clearInterval(intervalId);
        intervalId = null;
        return;
      }
      this.updateTimer(duration);
    }, 1000);
  }

  updateTimer(duration) {
    const timerUnits = {
      days: "days",
      hrs: "hours",
      mins: "minutes",
      secs: "seconds",
    };

    const markup = Object.entries(timerUnits)
      .map(([abbr, full]) => {
        return `<span class="timer-unit">
            ${String(duration[full]()).padStart(2, "0")} <small>${abbr}</small>
        </span>
     `;
      })
      .join('<span class="timer-divider">:</span>');

    this.timerCounter.innerHTML = markup;
  }

  /**
   * Handles the click event on the promo bar.
   *
   * - Checks if the Klaviyo popup should be opened on click based on the
   *   'openKlaviyoPopupOnClick' configuration.
   * - If enabled, prevents the default navigation behavior and opens the
   *   appropriate Klaviyo popup for desktop or mobile devices.
   * - Determines the device type by checking the window's inner width.
   *
   * @param {Event} event - The click event object triggered by the user.
   */

  handlePromoBarClick(event) {
    if (this.openKlaviyoPopupOnClick) {
      // Prevent the default navigation
      event.preventDefault();

      // Determine if the user is on mobile or desktop
      const isMobile = window.innerWidth <= 768;
      const klaviyoPopupId = isMobile
        ? this.klaviyoPopupIdMobile
        : this.klaviyoPopupIdDesktop;

      // Check if teaser exists first and click and return with klaviyoPopupId
      const teaser = document.querySelector(`.kl-teaser-${klaviyoPopupId}`);
      if (teaser) {
        console.log(`Teaser ${klaviyoPopupId} found, triggering click`);
        teaser.click();
        return;
      } else {
        console.log(`No teaser ${klaviyoPopupId} found, opening Klaviyo popup via javascript`);
      }
      // Trigger opening the Klaviyo popup if teaser was not found
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', klaviyoPopupId]);
    }
  }
}
customElements.define("promo-bar-metaobject", PromoBarMetaobject);
